import Infotip from "./Infotip";

export default Infotip;
